"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _excluded = ["title", "titleId"];
var SvgSpinner = function SvgSpinner(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12c-.8 0-1.5-.7-1.5-1.5v-5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v5c0 .8-.7 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 44c-.8 0-1.5-.7-1.5-1.5v-5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v5c0 .8-.7 1.5-1.5 1.5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.5h-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 13.8c-.5 0-1-.3-1.3-.8l-2.5-4.3c-.5-.7-.2-1.6.5-2 .7-.4 1.6-.2 2 .5l2.5 4.3c.4.7.2 1.6-.5 2-.2.2-.5.3-.7.3z",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3 41.5c-.5 0-1-.3-1.3-.8l-2.5-4.3c-.4-.7-.2-1.6.5-2 .7-.4 1.6-.2 2 .5l2.5 4.3c.4.7.2 1.6-.5 2-.2.3-.5.3-.7.3z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 34.8c-.5 0-1-.3-1.3-.8-.4-.7-.2-1.6.5-2l4.3-2.5c.7-.4 1.6-.2 2 .5.4.7.2 1.6-.5 2l-4.3 2.5c-.2.2-.5.3-.7.3z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 18.8c-.3 0-.5-.1-.7-.2L7.2 16c-.7-.4-1-1.3-.5-2s1.3-1 2-.5L13 16c.7.4 1 1.3.5 2-.2.5-.7.8-1.2.8z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 41.5c-.3 0-.5-.1-.7-.2-.7-.4-1-1.3-.5-2L16 35c.4-.7 1.3-1 2-.5.7.4 1 1.3.5 2L16 40.8c-.2.5-.7.7-1.3.7z",
    opacity: 0.25
  }));
};
var _default = SvgSpinner;
exports.default = _default;